import type { Plugin } from 'vue'
import { breakpointsTailwind } from '@vueuse/core'
const mq = useBreakpoints(breakpointsTailwind)

export const MQPlugin: Plugin = {
  install: (app) => {
    app.config.globalProperties.$mq = mq
    app.config.globalProperties.$isMobile = mq.smaller('md')
  }
}
